import useBreadcrumbs from '@admin/hooks/useAdminBreadcrumbs';
import PageHeader from '@shared/components/core/headers/PageHeader';
import SpacedLoader from '@shared/components/loading/SpacedLoader';
import InviteCreateAccess from '@shared/components/organization/invite/InviteCreateAccess';
import InvitePageContent from '@shared/components/organization/invite/InvitePageContent';
import { extractRoleProperties } from '@shared/hooks/helpers/OrganizationalHelpers';
import useCurrentOrgDetailsFetching from '@shared/hooks/useCurrentOrgDetailsFetching';
import { useCurrentOrgNavigation } from '@shared/hooks/useCurrentOrgNavigation';
import OrgPageTemplate from 'admin/components/organization/OrgPageTemplate';
import { useTranslation } from 'react-i18next';

export default function OrgInvitesPage() {
    useCurrentOrgNavigation();
    const { t } = useTranslation();
    const { items } = useBreadcrumbs();
    const { currentOrg, isExpiredOrg, membership, isLoading } = useCurrentOrgDetailsFetching();

    if (!currentOrg || isLoading) return <SpacedLoader />;
    return (
        <OrgPageTemplate>
            <PageHeader
                title={t('common:organization.invite.orgTitle', { value: currentOrg?.name })}
                description={t('common:organization.invite.description')}
                items={items}>
                {membership && !isExpiredOrg && currentOrg?.id && (
                    <InviteCreateAccess myRole={extractRoleProperties(membership)} organizationId={currentOrg.id} />
                )}
            </PageHeader>
            <InvitePageContent />
        </OrgPageTemplate>
    );
}
